import { Map } from 'immutable';

const CATEGORY_ATTENDACE = 'Behavior & Participation';

export const getAttendanceNoteByStudentIdAndSessionId = (state, studentId, sessionId) => {
  const notes = state.get('rootReducer').get('studentNotes');
  return Map.isMap(notes) && notes.findLast(
    (note) => eql(note.get('studentId'), studentId) &&
      note.get('category') === CATEGORY_ATTENDACE &&
      eql(note.get('entityId'), sessionId)
  );
};

function eql(source, target) {
  return `${source}` === `${target}`;
}

export const getNotes = (state) => state.get('rootReducer').get('studentNotes');




// WEBPACK FOOTER //
// ./containers/Student/Note/accessors.js